import LoadingButton from 'components/fantaclasse/LoadingButton';
import PropTypes from 'prop-types';
import React, { useCallback, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { supabase } from 'supabase/client';
import TurnstileCaptcha from './captcha/TurnstileCaptcha';

const ForgetPasswordForm = () => {
  // State
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [token, setToken] = useState('');

  const turnstileRef = useRef(null);

  // Handler
  const handleSubmit = async event => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      if (!token) {
        toast.error('Verifica il captcha');
        return;
      }
      try {
        setIsLoading(true);
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
          redirectTo: `${process.env.REACT_APP_FRONTEND_URL}/account/reset-password`,
          captchaToken: token // Include the Turnstile token
        });
        if (error) throw error;

        toast.success(
          <p className="mb-0">
            Un link per resettare la password è stato inviato a{' '}
            <strong>{email}</strong>
          </p>
        );
      } catch (error) {
        toast.error(
          <p className="mb-0">Errore nell'invio del link: {error.message}</p>
        );
        if (turnstileRef.current) {
          turnstileRef.current.reset();
        }
      } finally {
        setIsLoading(false);
      }
    }
    setValidated(true);
  };

  const handleTurnstileSuccess = useCallback(token => {
    setToken(token);
  }, []);

  return (
    <Form
      noValidate
      validated={validated}
      className="mt-4"
      onSubmit={handleSubmit}
    >
      <Form.Group>
        <Form.Control
          placeholder={'Email'}
          value={email}
          name="email"
          type="email"
          onChange={e => setEmail(e.target.value)}
          required
        />
        <Form.Control.Feedback type="invalid">
          Email non valida.
        </Form.Control.Feedback>
      </Form.Group>

      <TurnstileCaptcha onSuccess={handleTurnstileSuccess} ref={turnstileRef} />

      <Form.Group className="mb-3">
        <LoadingButton
          className="w-100"
          type="submit"
          disabled={!email || !token}
          isLoading={isLoading}
          text="Invia link di accesso"
        />
      </Form.Group>
      <p className="fs-10 text-600">
        Se non riesci a recuperare la tua password attraverso questa pagina,{' '}
        <a href="mailto:info@fantaclasse.it">
          <strong>contattaci</strong>.
        </a>
      </p>
    </Form>
  );
};

ForgetPasswordForm.propTypes = {
  layout: PropTypes.string
};

ForgetPasswordForm.defaultProps = { layout: 'simple' };

export default ForgetPasswordForm;
